export const MODAL_NAME = 'shipping.delete'
